module.exports = __webpack_public_path__ + "img/02.989256e7.png";